import { FC } from 'react';
import { useQRCode } from '~/assets/qr-code';
import { useDownloadPrompt } from '../../../assets/download-prompt';
import QRCodeBG from '../../../assets/qrcode-bg.svg?inline';
import { usePlatformDownloadButton } from '~/assets/download-platform';
import { useViewObserver } from '@lemon8/web-app-shared/util';
import { EPageModule } from '~/utils/page-module';
import { EClickPosition } from '~/utils/click-position';
import { useAtomValue } from 'jotai';
import { $FallbackGpToApk, $UserAgent } from '@lemon8/web-app-shared/atom';
import { activeToFeed } from '~/utils/active';
import { useBtnPortrait } from '../../1-main/assets/btn-portrait';

import './style.scss';

export const CommonSlideContentClassName = 'homepage-slide-common';

interface ICommonSlideContentProps {
  pageModule: EPageModule;
}

const BOTTOM_CTA_MAP: { [key in EPageModule]: EClickPosition } = {
  [EPageModule.OVERALL_INTRO]: EClickPosition.BOTTOM_BUTTON,
  [EPageModule.FEED_INTRO]: EClickPosition.FEED_BOTTOM_BUTTON,
  [EPageModule.SEARCH_INTRO]: EClickPosition.SEARCH_BOTTOM_BUTTON,
  [EPageModule.INTERACT_INTRO]: EClickPosition.INTERACT_BOTTOM_BUTTON,
  [EPageModule.LEMO_WELCOME]: EClickPosition.LEMO_BOTTOM_BUTTON,
};

export const CommonSlideContent: FC<ICommonSlideContentProps> = (props) => {
  const { pageModule } = props;
  const fallbackGpToApkConfig = useAtomValue($FallbackGpToApk);
  const { isMobile, isiOS, isMacOS } = useAtomValue($UserAgent);

  const QRCode = useQRCode();
  const DownloadPrompt = useDownloadPrompt();

  const DOWNLOAD_BTN = useBtnPortrait();
  const googlePlayDownloader = usePlatformDownloadButton(fallbackGpToApkConfig.enable ? 'APK' : 'Android');
  const appleStoreDownloader = usePlatformDownloadButton('iOS');

  const mobileDownloaderRef = useViewObserver<HTMLImageElement>({
    onView: () => {
      window.Tea('wap_cta_show', {
        current_page_module: pageModule,
        current_position: BOTTOM_CTA_MAP[pageModule],
      });
    },
  });

  const handleMobileDownloadClick = (): void => {
    window.Tea('wap_click', {
      current_page_module: pageModule,
      current_position: BOTTOM_CTA_MAP[pageModule],
      is_cta: 1,
    });
    activeToFeed({
      currentPosition: BOTTOM_CTA_MAP[pageModule],
    });
  };

  const handleAndroidDownloadClick = (): void => {
    window.Tea('wap_click', {
      current_page_module: pageModule,
      current_position: EClickPosition.DOWNLOAD_GOOGLE_PLAY,
      is_cta: 0,
    });
    activeToFeed({
      currentPosition: EClickPosition.DOWNLOAD_GOOGLE_PLAY,
    });
  };

  const handleIosDownloadClick = (): void => {
    window.Tea('wap_click', {
      current_page_module: pageModule,
      current_position: EClickPosition.DOWNLOAD_APPSTORE,
      is_cta: 0,
    });
    activeToFeed({
      currentPosition: EClickPosition.DOWNLOAD_APPSTORE,
    });
  };

  return (
    <>
      <img className="common-qrcode-wrapper" src={QRCodeBG} loading="lazy" />
      <img className="common-qrcode" src={QRCode.src} loading="lazy" />
      {isMobile ? (
        <img
          className="common-mobile-download-landscape"
          src={DOWNLOAD_BTN}
          ref={mobileDownloaderRef}
          onClick={handleMobileDownloadClick}
          loading="lazy"
        />
      ) : (
        <>
          <img
            className="common-app-store-landscape"
            {...appleStoreDownloader}
            onClick={handleIosDownloadClick}
            loading="lazy"
          />
          <img
            loading="lazy"
            className="common-google-play-landscape"
            {...googlePlayDownloader}
            onClick={handleAndroidDownloadClick}
          />
        </>
      )}
      <img className="common-download-prompt-landscape" src={DownloadPrompt} loading="lazy" />
    </>
  );
};
